<template>
    <!-- Navigation-->
    <nav class="navbar navbar-expand-lg py-3" id="mainNav">
        <div class="container pr-3 pl-3">
            <a class="navbar-brand js-scroll-trigger" href="/">
                <img class="mr-2" src="/img/eye.png" />
                <div class="mt-1 float-right">LOONATIC PRODUCTIONS</div>
            </a>
            <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"></span></button>
            <div class="collapse navbar-collapse" id="navbarResponsive">
                <ul class="navbar-nav ml-auto my-2 my-lg-0">
                    <li v-if="isNotHome" class="nav-item"><a class="nav-link js-scroll-trigger" href="/">Home</a></li>
                    <li v-if="isHome" class="nav-item"><a class="nav-link js-scroll-trigger" href="#about">About</a></li>
                    <li v-if="isHome" class="nav-item"><a class="nav-link js-scroll-trigger" href="#listen">Listen</a></li>
                    <li v-if="isHome" class="nav-item"><a class="nav-link js-scroll-trigger" href="#videos">Watch</a></li>
                    <li v-if="isHome" class="nav-item"><a class="nav-link js-scroll-trigger" href="#contact">Contact</a></li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
  name: "Header",
  computed: {
      isHome() {
         return this.$route.name === 'home'
     },
     isNotHome() {
        return this.$route.name !== 'home'
     }
    }
}
</script>

<style scoped>
</style>


